var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRental(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6583 11.3258H13.9907C14.3905 11.3258 14.657 11.0593 14.657 10.6596V8.66092C14.657 8.06132 14.1906 7.52834 13.6576 7.3951C12.4584 7.06198 10.6596 6.66225 10.6596 6.66225C10.6596 6.66225 9.79352 5.72953 9.19391 5.12993C8.8608 4.86344 8.46107 4.66357 7.99471 4.66357H3.33113C2.9314 4.66357 2.59829 4.93006 2.39842 5.26318L1.4657 7.19523C1.37748 7.45254 1.33246 7.72268 1.33246 7.9947V10.6596C1.33246 11.0593 1.59895 11.3258 1.99868 11.3258H3.33113",
    stroke: "black",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66357 12.6583C5.39946 12.6583 5.99602 12.0617 5.99602 11.3258C5.99602 10.5899 5.39946 9.99338 4.66357 9.99338C3.92767 9.99338 3.33112 10.5899 3.33112 11.3258C3.33112 12.0617 3.92767 12.6583 4.66357 12.6583Z",
    stroke: "black",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99603 11.3258H9.99338",
    stroke: "black",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3258 12.6583C12.0617 12.6583 12.6582 12.0617 12.6582 11.3258C12.6582 10.5899 12.0617 9.99338 11.3258 9.99338C10.5899 9.99338 9.99335 10.5899 9.99335 11.3258C9.99335 12.0617 10.5899 12.6583 11.3258 12.6583Z",
    stroke: "black",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9894,
    height: 15.9894,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRental);
export default __webpack_public_path__ + "static/media/rental.fc1a5444cfd0c3b293bfdc4b11591711.svg";
export { ForwardRef as ReactComponent };